import i18n from '@/i18n'

function lang(): string {
  return i18n.resolvedLanguage ?? i18n.language ?? 'en'
}

export function formatNumber(value: number | bigint): string {
  return new Intl.NumberFormat(lang()).format(value)
}

export function formatCompact(value: number | bigint): string {
  return new Intl.NumberFormat(lang(), { notation: 'compact', maximumFractionDigits: 1 }).format(value)
}

/** "2h 43m", "4m 10s", "12s" — the format the mobile dossier uses. */
export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000))
  const d = Math.floor(total / 86_400)
  const h = Math.floor((total % 86_400) / 3600)
  const m = Math.floor((total % 3600) / 60)
  const s = total % 60
  if (d > 0) return `${d}d ${h}h`
  if (h > 0) return `${h}h ${String(m).padStart(2, '0')}m`
  if (m > 0) return `${m}m ${String(s).padStart(2, '0')}s`
  return `${s}s`
}

/** Locale-aware "5 minutes ago". */
export function formatAgo(ms: number): string {
  const rtf = new Intl.RelativeTimeFormat(lang(), { numeric: 'auto', style: 'short' })
  const sec = Math.round(ms / 1000)
  if (sec < 60) return rtf.format(-sec, 'second')
  const min = Math.round(sec / 60)
  if (min < 60) return rtf.format(-min, 'minute')
  const hr = Math.round(min / 60)
  if (hr < 48) return rtf.format(-hr, 'hour')
  return rtf.format(-Math.round(hr / 24), 'day')
}

export function toMs(v: bigint | number | undefined | null): number {
  if (v === undefined || v === null) return 0
  return typeof v === 'bigint' ? Number(v) : v
}
